<template>
    <div class="form__container">
        <p class="form__heading">
            <span>{{ inputData.name }}</span>
        </p>
        <p class="form__description" v-if="inputData.desc">{{ inputData.desc }}</p>
    </div>
</template>

<script>
export default {
    props: ['inputData'],
}
</script>